module.exports = __webpack_public_path__ + "img/icon-dropupeditor.80b188f5.svg";